// src/ui/carregando.js
// Overlay de carregamento da SECAO (troca de tela): logo + spinner sobre a area de conteudo,
// com pequeno atraso para nao "piscar" em trocas rapidas. Mantem a sidebar e o topbar visiveis.
import { el } from '../lib/dom.js';

let timer = null;
let seq = 0;

function overlay() {
  const main = document.querySelector('.main');
  if (!main) return null;
  let ov = main.querySelector(':scope > .nav-loading');
  if (!ov) {
    ov = el('div', { class: 'nav-loading', style: 'display:none' }, [
      el('img', { class: 'nav-loading__img', src: '/logo.png', alt: '' }),
      el('div', { class: 'nav-loading__spin' }),
      el('div', { class: 'nav-loading__txt', text: 'Carregando…' }),
    ]);
    main.append(ov);
  }
  return ov;
}

/** Inicia o carregamento da secao (so aparece apos ~150ms; troca rapida nao chega a mostrar). Retorna fn para parar. */
export function iniciarCarregamentoSecao() {
  const meu = ++seq;
  clearTimeout(timer);
  timer = setTimeout(() => {
    if (meu !== seq) return;
    const ov = overlay();
    if (!ov) return;
    const tb = document.querySelector('.main > .topbar');
    ov.style.top = (tb ? tb.offsetHeight : 0) + 'px'; // comeca abaixo da topbar (mantem waffle/operador/conta visiveis)
    ov.style.display = '';
  }, 150);
  return () => {
    if (meu !== seq) return; // uma navegacao mais nova assumiu; nao mexe no overlay dela
    clearTimeout(timer);
    const ov = document.querySelector('.main > .nav-loading');
    if (ov) ov.style.display = 'none';
  };
}